<template>
  <el-avatar :class="style.avatar" @error="errorHandler">
    <img
      src="https://s3.ap-northeast-1.amazonaws.com/s3.toobit.com/images/account_icon/1533208313-1.png"
    >
  </el-avatar>
</template>

<script lang="ts" setup>
const errorHandler = () => true;
</script>

<style lang="scss" module="style">
.avatar {
  --el-avatar-bg-color: transparent;
}
</style>
